import { earth_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"
const cxMap = {
  name: "cxMap",
  desc: "",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    bigScreen: [
      {
        name: "3D地球",
        children: earth_children,
        type: "mapComponent",
        group: "chart",
        sort: 40
      }
    ]
  },
  toolbars: [
    {
      name: "cxMap",
      label: "3D地球",
      comp: {
        mapComponentData: () => import("./toolbars/map-options-data.vue"),
        mapComponentSetting: () => import("./toolbars/map-options-setting.vue"),
        mapComponentStyle: () => import("./toolbars/map-options-style.vue")
      }
    }
  ]
}

export default cxMap
